import { MTextField, ResponsiveFormContainer } from "@app/components";
import { MODES_OPTIONS } from "@app/types/generics.types";
import React from "react";

interface MailFormProps {
  mode: MODES_OPTIONS;
  disabled?: boolean;
}

const MailForm = ({ mode, disabled }: MailFormProps) => {
  const isView = mode === MODES_OPTIONS.VIEW;

  return (
    <>
      <ResponsiveFormContainer columns={2} mt={2}>
        <MTextField
          name="letter_content"
          label="Notas de la carta"
          placeholder="Notas de la carta"
          type="textArea"
          rows={4}
          multiline
          fullWidth
          validation={{ required: "Las notas de la carta son requeridas" }}
          disabled={isView || disabled}
        />
      </ResponsiveFormContainer>
    </>
  );
};

export default MailForm;
